import { skipTracingStore } from "../store";
import { useSnapshot } from "valtio";

export const useSelectedStageId = () => {
  const { selectedStageId } = useSnapshot(skipTracingStore);

  return selectedStageId;
};
